import React, { useState, useRef, useMemo, useEffect } from "react";
import JoditEditor from "jodit-react";
import ReactSelect from 'react-select';
import { changePartnerEarningWithdrawRequestStatusApi, cityByCountryApi, countryListApi, getJobCategoryApi, partnerEarningWithdrawRequestApi, uploadFileApi } from '../../../utils/ApiEndpointFunctions';
import toast from "react-hot-toast";
import { S3_URL } from "../../../utils/BaseUrl";

import { convertByteToMB } from "../../../utils/HelperFuncitons";
import Spinwheel from "../../common/Spinwheel";
import { useFormik } from "formik";
import { useAdminContext } from "../../../context/adminContext";

const AddOrUpdateJob = ({ modalId, formik, loading, countryOptions }) => {
  const [jobCategory, setJobCategory] = useState();
    const { adminDetail } = useAdminContext();
  //  const [countryOptions, setCountryOptions] = useState([])
      const [cityOptions, setCityOptions] = useState([])
    
     const isSuperAdmin = adminDetail?.role === "superAdmin";

    const isCountryDisabled = !isSuperAdmin;

  const filterCites = async (countryId) => {
    try {
      const res = await cityByCountryApi("", countryId)
      if (res.status === 200) {
        let cityOption = res.data?.data?.map(ele => ({ label: ele.name, value: ele.id }))
        setCityOptions(cityOption);
      }

    } catch (error) {
      console.log(error)
    }
  };


  const handleCountryChange = (country) => {
    formik.setFieldValue("countryId", country);
    formik.setFieldValue("cityId", null);
    if (country?.value) {
      filterCites(country.value);
    }
  };

  const handleCityChange = (city) => {
    formik.setFieldValue("cityId", city);
  };



useEffect(() => {
  if (adminDetail && adminDetail.role !== 'superAdmin') {
    const defaultCountryOption = {
      label: adminDetail.countryName,
      value: adminDetail.countryId
    };

    formik.setFieldValue('countryId', defaultCountryOption);  
    filterCites(defaultCountryOption.value);
  }
}, [adminDetail]);

    
  const getAllJobCategoryList = async (selectedPage, limit) => {
    try {
      const res = await getJobCategoryApi();
      if (res.status === 200 || res.status === 201) {
        setJobCategory(res?.data?.data);
      }
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    getAllJobCategoryList();
  }, []);
  
    useEffect(() => {
      if (adminDetail?.countryId) {
        filterCites(adminDetail.countryId);
      }
    }, [adminDetail]);
  

  // const fileInputRef = useRef(null);
  // const fileUploadHandler = async (e) => {
  //   try {
  //     const FILE_ACCEPT = ["image/jpg", "image/jpeg", "image/png"];

  //     const file = e.target.files[0];
  //     if (file) {
  //       if (!FILE_ACCEPT.includes(file.type)) {
  //         toast.error("Invalid File Format");
  //         return;
  //       }

  //       const fileSizeInMB = convertByteToMB(file.size || 0);

  //       if (fileSizeInMB > 5) {
  //         return toast.error("File Size Exceeds. Max Image Should be of 5 MB");
  //       }

  //       formik.setFieldTouched("logo", true);
  //       const formData = new FormData();
  //       formData.append("file", file);
  //       formData.append("type", "driver");

  //       const res = await uploadFileApi(formData);
  //       if (res.status === 200 && res.data?.status === 1) {
  //         toast.success("File uploaded");
  //         formik.setFieldValue("logo", res.data?.data);
  //       }
  //     }
  //   } catch (error) {
  //     console.log(error);
  //     if (error?.response === undefined) {
  //       toast.error(
  //         "There was an error uploading your file. Please try again later."
  //       );
  //     }
  //   }
  // };

  const editor = useRef(null);

  return (
    <div
      className={`modal fade`}
      id={modalId}
      tabIndex="-1"
      aria-labelledby="blogAddModalLabel"
      aria-hidden="true"
    >
      <div className="modal-dialog modal-xl">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title" id="blogAddModalLabel">
              {formik?.values?.id ? "Update" : "Add"} Job
            </h5>
            <button
              type="button"
              className="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
          <div className="modal-body">
            <form onSubmit={formik?.handleSubmit}>
              
              <div className="row mb-3">
                <div className="col-md-6">
                  <label htmlFor="isDisclosed" className="form-label">
                    Disclose
                  </label>
                  <div className="form-check form-switch mb-3">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      id="isDisclosed"
                      role="switch"
                      checked={formik.values.isDisclosed}
                      onChange={() =>
                        formik.setFieldValue(
                          "isDisclosed",
                          !formik.values.isDisclosed
                        )
                      }
                    />
                  </div>
                  <label htmlFor="isOpen" className="form-label">
                    Open
                  </label>
                  <div className="form-check form-switch">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      id="isOpen"
                      role="switch"
                      checked={formik.values.isOpen}
                      onChange={() =>
                        formik.setFieldValue("isOpen", !formik.values.isOpen)
                      }
                    />
                  </div>
                </div>

                {/* Right 50%: Logo upload & preview */}
                {/* <div className="col-md-6">
                  <label className="form-label fw-semibold">Logo</label>
                  <div
                    className="border rounded d-flex justify-content-center align-items-center bg-light"
                    style={{
                      cursor: "pointer",
                      minHeight: "200px",
                      position: "relative",
                      overflow: "hidden",
                    }}
                    onClick={() => fileInputRef.current?.click()}
                  >
                    {
                      formik.values.logo ? (
                        <img
                          src={S3_URL + "/" + formik.values.logo}
                          alt="Logo Preview"
                          style={{
                            width: "100%",
                            height: "100%",
                            objectFit: "contain",
                            position: "absolute",
                            top: 0,
                            left: 0,
                          }}
                        />
                      ) : (
                        <span className="text-muted">Choose a file</span>
                      )
                    }
                  </div>
                  <input
                    type="file"
                    className="d-none"
                    ref={fileInputRef}
                    name="logo"
                    onChange={fileUploadHandler}
                    onBlur={formik.handleBlur}
                  />
                  {formik.touched.logo && formik.errors.logo && (
                    <div className="text-danger mt-1">{formik.errors.logo}</div>
                  )}
                </div> */}
              </div>

              <div className="row mb-3">
                <div className="col-md-4 mb-3">
                  <label htmlFor="title" className="form-label">
                    Job title
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    id="title"
                    name="title"
                    placeholder="Enter"
                    value={formik?.values?.title}
                    onChange={formik?.handleChange}
                    onBlur={formik?.handleBlur}
                  />
                  {formik?.touched?.title && formik?.errors?.title && (
                    <div className="req-error">{formik.errors.title}</div>
                  )}
                </div>

                <div className="col-md-4 mb-3">
                  <label htmlFor="jobType" className="form-label">
                    Job type
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    id="jobType"
                    name="jobType"
                    placeholder="Enter"
                    value={formik?.values?.jobType}
                    onChange={formik?.handleChange}
                    onBlur={formik?.handleBlur}
                  />
                  {formik?.touched?.jobType && formik?.errors?.jobType && (
                    <div className="req-error">{formik.errors.jobType}</div>
                  )}
                </div>

                <div className="col-md-4 mb-3">
                  <label htmlFor="package" className="form-label">
                    Package (per annum)
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    id="package"
                    name="package"
                    placeholder="Enter"
                    value={formik?.values?.package}
                    onChange={formik?.handleChange}
                    onBlur={formik?.handleBlur}
                  />
                  {formik?.touched?.package && formik?.errors?.package && (
                    <div className="req-error">{formik.errors.package}</div>
                  )}
                </div>
              </div>

              <div className="row mb-3">
                {/* <div className="col-md-4 mb-3">
                  <label htmlFor="location" className="form-label">
                    Location
                <div className="col-md-4 mb-3">
                  <label htmlFor="email" className="form-label">
                    Email
                  </label>
                  <input
                    type="email"
                    className="form-control"
                    id="email"
                    name="email"
                    placeholder="Enter"
                    value={formik?.values?.email}
                    onChange={formik?.handleChange}
                    onBlur={formik?.handleBlur}
                  />
                  {formik?.touched?.email && formik?.errors?.email && (
                    <div className="req-error">{formik.errors.email}</div>
                  )}
                </div> */}

                <div className="col-md-4 mb-3">
                  <label htmlFor="email" className="form-label">
                    Email
                  </label>
                  <input
                    type="email"
                    className="form-control"
                    id="email"
                    name="email"
                    placeholder="Enter"
                    value={formik?.values?.email}
                    onChange={formik?.handleChange}
                    onBlur={formik?.handleBlur}
                  />
                  {formik?.touched?.email && formik?.errors?.email && (
                    <div className="req-error">{formik.errors.email}</div>
                  )}
                </div>
                
                <div className="col-md-4 mb-3">
                  <label htmlFor="countryId" className="form-label">Country</label>
                  <ReactSelect
                    inputId="countryId"
                    options={countryOptions}
                    value={formik.values.countryId} // <-- use directly from Formik
                    onChange={handleCountryChange}
                    onBlur={formik.handleBlur}
                    classNamePrefix="react-select"
                    className="react-select-container"
                    isDisabled={isCountryDisabled}
                    name="countryId"
                    noOptionsMessage={() => 'No Countries Available'}
                  />
                  {formik.touched.countryId && formik.errors.countryId && (
                    <div className="req-error">{formik.errors.countryId}</div>
                  )}

                </div>

                {/* City */}
                <div className="col-md-4 mb-3">
                  <label htmlFor="cityId" className="form-label">City</label>
                  <ReactSelect
                    inputId="cityId"
                    options={cityOptions}
                    value={formik.values.cityId}  
                    onChange={handleCityChange}
                    onBlur={formik.handleBlur}
                    classNamePrefix="react-select"
                    className="react-select-container"
                    isDisabled={!formik.values.countryId}
                    name="cityId"
                    noOptionsMessage={() => 'No Cities Available'}
                  />
                  {formik.touched.cityId && formik.errors.cityId && (
                    <div className="req-error">{formik.errors.cityId}</div>
                  )}
                </div>
              </div>
              <div className="row mb-3">
                <div className="col-md-4 mb-3">
                  <label htmlFor="experience" className="form-label">
                    Experience
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    id="experience"
                    name="experience"
                    placeholder="Enter"
                    value={formik?.values?.experience}
                    onChange={formik?.handleChange}
                    onBlur={formik?.handleBlur}
                  />
                  {formik?.touched?.experience &&
                    formik?.errors?.experience && (
                      <div className="req-error">
                        {formik.errors.experience}
                      </div>
                    )}
                </div>

                <div className="col-md-4 mb-3">
                  <label htmlFor="education" className="form-label">
                    Education
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    id="education"
                    name="education"
                    placeholder="Enter"
                    value={formik?.values?.education}
                    onChange={formik?.handleChange}
                    onBlur={formik?.handleBlur}
                  />
                  {formik?.touched?.education && formik?.errors?.education && (
                    <div className="req-error">{formik.errors.education}</div>
                  )}
                </div>
                <div className="col-md-4 mb-3">
                  <label htmlFor="categoryId" className="form-label">
                    Category
                  </label>
                  <select
                    className="form-select"
                    name="categoryId"
                    id="categoryId"
                    value={formik?.values?.categoryId}
                    onChange={formik?.handleChange}
                    onBlur={formik?.handleBlur}
                  >
                    <option value="">Select category</option>
                    {jobCategory?.map((ele, index) => {
                      return <option key={index} value={ele.id}>{ele.categoryName}</option>;
                    })}
                  </select>
                  {formik?.touched?.categoryId && formik?.errors?.categoryId ? (
                    <div className="req-error">
                      {formik?.errors?.categoryId}
                    </div>
                  ) : null}
                </div>

              </div>

              <div className="mb-3">
                <label htmlFor="content" className="form-label">
                  Description
                </label>
                <JoditEditor
                  ref={editor}
                  value={formik?.values?.description}
                  // config={config}
                  onBlur={(e) => {
                    formik.setFieldTouched("description", true);
                    e === "<p><br></p>"
                      ? formik.setFieldValue("description", "")
                      : formik.setFieldValue("description", e);
                  }}
                  onChange={(newContent) => {}}
                />
                {formik?.touched?.description && formik?.errors?.description ? (
                  <div className="req-error">{formik?.errors?.description}</div>
                ) : null}
              </div>
              <div className="mb-3">
                <label htmlFor="responsibilities" className="form-label">
                  Responsibilities
                </label>
                <JoditEditor
                  ref={editor}
                  value={formik?.values?.responsibilities}
                  // config={config}
                  onBlur={(e) => {
                    formik.setFieldTouched("responsibilities", true);
                    e === "<p><br></p>"
                      ? formik.setFieldValue("responsibilities", "")
                      : formik.setFieldValue("responsibilities", e);
                  }}
                  onChange={(newContent) => {}}
                />
                {formik?.touched?.responsibilities &&
                formik?.errors?.responsibilities ? (
                  <div className="req-error">
                    {formik?.errors?.responsibilities}
                  </div>
                ) : null}
              </div>
              <button
                type="submit"
                className="btn btn-primary"
                disabled={loading}
              >
                {" "}
                {loading ? <Spinwheel sizeClass={"spin-small"} /> : "Submit"}
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddOrUpdateJob;
